import React, { HTMLAttributes } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Item from "./Item";
import { IItem } from ".";

export interface ISortableItemProps extends HTMLAttributes<HTMLDivElement> {
  item: IItem;
  onRemove: (id: number) => void;
  onChangeFile?: (id: number, file: File) => void;
  open?: () => void;
}

export const SortableItem = ({
  item,
  onRemove,
  onChangeFile,
  open,
  ...props
}: ISortableItemProps) => {
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.id });

  const styles = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
  };

  return (
    <Item
      onRemove={onRemove}
      onChangeFile={onChangeFile}
      open={open}
      item={item}
      ref={setNodeRef}
      style={styles}
      isOpacityEnabled={isDragging}
      {...props}
      {...attributes}
      {...listeners}
    />
  );
};
